import React from 'react'
import Lsb from './Global-content/Lsb'
import Herosec from './Main-Components/Herosec'
import Portfolio from './Main-Components/Portfolio'
import About from './Main-Components/About'
import Resume from './Main-Components/Resume'
import Skills from './Main-Components/Skills'
import Contact from './Main-Components/Contact'

export default function MainWrapper() {
  return (
    <main className="portfolio-main">
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <div className="main-container">
            <Lsb/> 
            <div className="main-content">
              <Herosec/>
              <Portfolio/>
              <About/>
              <Resume/>
              <Skills/>
              <Contact/>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
